import { CalendarDays, CheckCircle2, Clock, MapPin } from "lucide-react";
import type { CSSProperties } from "react";
import { categoryById } from "../data/categories";
import type { Place } from "../data/schema";
import {
  indoorOutdoorLabels,
  priceLabels,
  regionLabels,
  stayTimeLabels,
  weekdayLabels,
} from "../lib/labels";

interface PlaceCardProps {
  place: Place;
  selected: boolean;
  onSelect: (place: Place) => void;
}

export function PlaceCard({ place, selected, onSelect }: PlaceCardProps) {
  const category = categoryById[place.category];

  return (
    <article className={selected ? "place-card selected" : "place-card"}>
      <button className="card-main" onClick={() => onSelect(place)} type="button">
        <div className="card-topline">
          <span
            className="category-pill"
            style={{ "--pill-color": category.color } as CSSProperties}
          >
            {category.name}
          </span>
          <span className="card-open-label">자세히 ↗</span>
        </div>
        <h3>{place.name}</h3>
        <p>{place.summary}</p>
        <div className="meta-row">
          <span>
            <MapPin size={14} aria-hidden="true" />
            {regionLabels[place.region]} · {place.district}
          </span>
          <span>
            <Clock size={14} aria-hidden="true" />
            {stayTimeLabels[place.stayTime]}
          </span>
        </div>
        <div className="mini-tags">
          <span>{indoorOutdoorLabels[place.indoorOutdoor]}</span>
          <span>{priceLabels[place.priceType]}</span>
          {place.rainFriendly && <span>비 오는 날</span>}
          {place.reservationRequired && <span>예약</span>}
        </div>
      </button>

      <div className="card-detail">

        {place.kidsCafe && (
          <div className="kids-cafe-detail">
            {place.kidsCafe.childFee && <span>아이 {place.kidsCafe.childFee}</span>}
            {place.kidsCafe.guardianFee && <span>보호자 {place.kidsCafe.guardianFee}</span>}
            {place.kidsCafe.parkingNote && <span>{place.kidsCafe.parkingNote}</span>}
            {place.kidsCafe.reservationNote && <span>{place.kidsCafe.reservationNote}</span>}
          </div>
        )}
        <div className="open-days">
          <CalendarDays size={15} aria-hidden="true" />
          {place.openDays.map((day) => weekdayLabels[day]).join(" ")}
          {place.closedNote && <small>{place.closedNote}</small>}
        </div>
        <div className="source-row">
          <CheckCircle2 size={15} aria-hidden="true" />
          {place.source[0]?.checkedAt ? `정보 확인 ${place.source[0].checkedAt}` : "방문 전 운영정보 확인"}
        </div>
      </div>
    </article>
  );
}
